import { Image } from 'expo-image';
import { ReactNode } from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

import { Button, tokens } from '@fhs/ui';
import { ButtonType } from '@fhs/ui/src/components/button/types';

export interface DisplayCardProps {
  image: string | ReactNode;
  children: ReactNode;
  button?:
    | {
        label: string;
        onPress: () => void;
        type?: ButtonType;
        disabled?: boolean;
      }
    | ReactNode;
  style?: StyleProp<ViewStyle>;
}

function isButtonConfig(button: any): button is { label: string; onPress: () => void } {
  return typeof button === 'object' && button && 'onPress' in button && 'label' in button;
}
export function DisplayCard({ image, children, button, style }: DisplayCardProps) {
  const isButtonObject = isButtonConfig(button);

  return (
    <View style={[styles.container, style]}>
      {typeof image === 'string' ? (
        <Image contentFit="contain" source={{ uri: image }} style={styles.image} />
      ) : (
        image
      )}
      <View style={styles.content}>{children}</View>
      {isButtonObject ? (
        <Button
          size="sm"
          disabled={button.disabled}
          type={button.type ?? 'outline-subtle'}
          onPress={button.onPress}
        >
          <Button.Text>{button.label}</Button.Text>
        </Button>
      ) : (
        button
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    padding: 16,
    alignItems: 'center',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: tokens.colors.$blackOpacity10,
  },
  content: {
    flex: 1,
    marginLeft: 12,
  },
  image: {
    height: 40,
    width: 40,
  },
});
